export interface AuditEventOption {
  value: string;
  label: string;
}

export const AUDIT_EVENT_OPTIONS: AuditEventOption[] = [
  { value: "", label: "Todos os eventos" },
  { value: "Export", label: "Exportação" },
  { value: "Create", label: "Criação" },
  { value: "Update", label: "Atualização" },
  { value: "SAVE", label: "Salvamento" },
  { value: "StatusChange", label: "Alteração de status" },
  { value: "MOVE_CATEGORY", label: "Movimentação de categoria" },
  { value: "TRANSFER_CATEGORY", label: "Transferência de categoria" },
  { value: "TRANSFER_SERVICE", label: "Transferência de serviço" },
];
